var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardRecommendation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#D6E9D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7167 36.3671C58.7167 36.6633 58.4744 36.9055 58.1781 36.9055H56.9055V38.1782C56.9055 38.4743 56.6634 38.7166 56.3674 38.7166H55.6329C55.3371 38.7166 55.0949 38.4743 55.0949 38.1782V36.9055H53.8219C53.5261 36.9055 53.2837 36.6633 53.2837 36.3671V35.6329C53.2837 35.3368 53.5261 35.0946 53.8219 35.0946H55.0949V33.8218C55.0949 33.5257 55.3371 33.2834 55.6329 33.2834H56.3674C56.6634 33.2834 56.9055 33.5257 56.9055 33.8218V35.0946H58.1781C58.4744 35.0946 58.7167 35.3368 58.7167 35.6329V36.3671ZM60.9999 36C60.9999 33.2387 58.7614 31 56.0002 31C55.949 31 55.8975 31.0008 55.8459 31.0024C53.1095 31.0848 51 33.4722 51 36.21V45.7C51 45.8657 51.1344 46 51.3001 46H60.7906C63.5283 46 65.9157 43.8904 65.9977 41.1539C66.0828 38.3222 63.8125 36 60.9999 36Z",
    fill: "#143328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4853 30L42.9706 38.4853L34.4853 46.9706",
    stroke: "#143328",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4853 30L32.9706 38.4853L24.4853 46.9706",
    stroke: "#143328",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 38.5L16 38.5",
    stroke: "#143328",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRecommendation);
export default __webpack_public_path__ + "static/media/dashboard-recommendation.ea6f9bdada8b0c1847267300b1fb571b.svg";
export { ForwardRef as ReactComponent };